import axios from "axios";

export function addParticipant(data){
    return axios.request({
        method:'POST',
        data:data,
        url:'/api/quiz/addParticipant'
    })
}